import { apiRequest } from './api';

/** Parent side of YOYO Picks submissions (PRD §6.3). */
export interface PickSubmissionPayload {
  type: 'PROVIDER' | 'EVENT';
  titleCN: string | null;
  titleEN: string | null;
  providerName: string;
  externalUrl: string;
  region: string[];
  cityCN: string | null;
  cityEN: string | null;
  addressLine: string | null;
  ageMin: number;
  ageMax: number;
  participation: string;
  language: string;
  category: string;
  priceNoteCN: string | null;
  priceNoteEN: string | null;
  scheduleNoteCN: string | null;
  scheduleNoteEN: string | null;
  occurrences: { startTime: string; endTime: string }[];
  reason: string;
  visited: boolean;
  displayNameMode: 'account' | 'custom' | 'anonymous';
  customName?: string;
  note?: string;
  /** The person's own smart-intake draft, reused instead of creating a second one. */
  draftPickId?: string;
}

export type SubmissionStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'MERGED';

export interface MySubmission {
  id: string;
  slug: string;
  status: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
  titleCN: string | null;
  titleEN: string | null;
  providerName: string;
  submissionStatus: SubmissionStatus;
  rejectionReason: string | null;
  createdAt: string;
  mergedInto: {
    slug: string;
    titleCN: string | null;
    titleEN: string | null;
    status: string;
  } | null;
}

export const picksApi = {
  async submit(payload: PickSubmissionPayload): Promise<{ id: string }> {
    const res = await apiRequest<{ success: boolean; data: { id: string } }>('/picks/submissions', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return res.data;
  },
  async checkDuplicate(input: {
    type: 'PROVIDER' | 'EVENT';
    providerName: string;
    externalUrl: string;
    title: string;
  }) {
    const res = await apiRequest<{ success: boolean; data: { duplicate: boolean } }>(
      '/picks/submissions/check',
      { method: 'POST', body: JSON.stringify(input) }
    );
    return res.data;
  },
  async mySubmissions(): Promise<MySubmission[]> {
    const res = await apiRequest<{ success: boolean; data: MySubmission[] }>(
      '/picks/submissions/me'
    );
    return res.data;
  },
};
